import type { dedupeIntegration } from "@sentry/react";
type Integration = ReturnType<typeof dedupeIntegration>;

/** The queue's durable daily/change marker owns deduplication for blocked sync events. */
export function preserveBlockedSyncEvents(
  integrations: Integration[],
): Integration[] {
  return integrations.map((integration) =>
    integration.name !== "Dedupe" || !integration.processEvent
      ? integration
      : {
          ...integration,
          processEvent(event, hint, client) {
            return event.message === "Inspection sync blocked"
              ? event
              : integration.processEvent!(event, hint, client);
          },
        },
  );
}
